import React from 'react';
import { GrandTest } from './GrandTest';
import { PopularCourses } from './PopularCourses';
import { SeriesList } from './SeriesList';
import { Slider } from './Slider';

export default function Home() {
  return (
    <div>
      <div className='container'>
        <Slider />
        <PopularCourses />
        {/* <MockTestList /> */}
        <SeriesList />
        <GrandTest />
      </div>
    </div>
  );
}
